import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, InputAdornment, Button, Switch, CircularProgress } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { LinkOutlined, YouTube, CloudDoneOutlined } from '@material-ui/icons';
import { fb } from '../../utils/Firebase';

const VideoForm = props => {

    const [switchBtn, setSwitchBtn] = useState({
        message: 'Ocultar',
        enabled: true
    });
    const [isLoading, setIsLoading] = useState(false);
    const classes = useStyles();
    const { handleSubmit, control, errors,  } = useForm();

    const { state } = props;

    useEffect(() => {
        let subscribed = true;
        subscribed &&  handleSwitchBtn(state.video.visible);
        return () => subscribed = false;
    }, []);

    const handleSwitchBtn = e => {
        !e ? setSwitchBtn({ message: 'Mostrar', enabled: false }) : setSwitchBtn({ message: 'Ocultar', enabled: true })
    }

    const onSubmit = async data => {
        setIsLoading(true);
        const { urlvideo, visiblevideo } = data;

        const payload = {
            video: {
                url: urlvideo,
                visible: visiblevideo
            }
        }
        
        try {
            await fb.firestore().collection('configuraciones').doc('principal').set(payload, { merge: true });
        }catch(e) {
            console.log(e);
        }
        setIsLoading(false);
    }

    return (
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
            <div className={classes.containerVideo}>
                <section className={classes.title}>
                    <YouTube htmlColor='rgba(0, 0, 0, .5)' />
                    <h3 className={classes.text}>Video</h3>
                </section>
                <Controller
                    name='urlvideo'
                    control={control}
                    defaultValue={state?.video?.url}
                    render={({ onChange, value }) => (
                        <TextField
                            disabled={isLoading}
                            error={errors.urlvideo ? true : false}
                            label='Url'
                            helperText={errors.urlvideo ? errors.urlvideo.message : 'Ingrese la url'}
                            size='small'
                            variant="outlined"
                            style={{ marginBottom: 15, background: '#fff' }}
                            value={value}
                            onChange={onChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LinkOutlined htmlColor='grey' />
                                    </InputAdornment>
                                )
                            }}
                        />
                    )}
                    rules={{
                        pattern: {
                            value: /^https\:\/\/w{3}\.youtube\.com\/embed\/[a-zA-Z0-9]+[\S]$/g,
                            message: 'La url no es correcta'
                        },
                    }}
                />

                <div>
                    <span className={classes.switchText}>{switchBtn.message}</span>
                    <Controller
                        name='visiblevideo'
                        control={control}
                        defaultValue={state?.video?.visible}
                        render={({ onChange, value }) => (
                            <Switch
                                disabled={isLoading}
                                color="primary"
                                checked={value}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                    handleSwitchBtn(e.target.checked);
                                }}
                            />
                        )}
                    />
                </div>
            </div>

            <Button
                variant="contained"
                startIcon={isLoading ? <CircularProgress size={20} color='inherit' /> : <CloudDoneOutlined />}
                disabled={isLoading}
                style={{ background: '#4caf50', color: '#fff', width: 150 }}
                type='submit'
            >
                {isLoading ? 'Guardando...' : 'Guardar'}
            </Button>
        </form>
    );
}

const useStyles = makeStyles({
    containerVideo: {
        background: '#fff',
        marginTop: 10,
        marginBottom: 10,
        borderRadius: 6,
        paddingLeft: 20,
        paddingRight: 20
    },
    title: {
        display: 'flex',
        alignItems: 'center'
    },
    text: {
        color: 'rgba(0, 0, 0, .5)',
        marginLeft: 10
    },
    form: {
        //width: 400,
        display: 'flex',
        flexDirection: 'column'
    },
    switchText: {
        color: 'grey'
    }
});

export default VideoForm;